// How long a row that arrived through the "N new" pill stays tinted, unless the reader sees
// it first. Long enough to find what changed after glancing away, short enough that "new"
// still means new. NowPage's timers, the legend's wording and the tests all read this one value.
export const NEW_ROW_MINUTES = 10;

/** {@link NEW_ROW_MINUTES} in milliseconds. */
export const NEW_ROW_MS = NEW_ROW_MINUTES * 60 * 1000;

/**
 * Applying the pill scrolls the list to the top, which can leave a stationary pointer over a
 * new row and fire `mouseenter` at once. A pointer arriving within this long of the apply is
 * not the reader looking at that row, so it does not clear the tint; a click or the reader's
 * own focus still does.
 */
export const SEEN_GRACE_MS = 300;
